import React from "react";
import newUser from "assets/images/user-image.png";
import { isMobile } from "react-device-detect";
import { RiFlightLandFill, RiFlightTakeoffFill } from "react-icons/ri";
class ResourceCell extends React.PureComponent {
  render() {
    const {
      data: {
        color,
        text,
        data: { emp_pic, staff_name },
      },
    } = this.props;
    /*
          <div className="dx-template-wrapper">
        <div className="name" style={{ background: color }}>
          <div className="col-12 d-flex justify-content-center">
            <img src={emp_pic ? emp_pic : newUser} className="avatar" />
          </div>
          <div className="col-12 d-flex justify-content-center">
            <p className="text-center pt-0 fs-12">{staff_name}</p>
          </div>
        </div>
      </div>*/
        /*
        <div className="name" style={{ background: color }}>
          <div className="col-12 d-flex justify-content-left">
            <img src={emp_pic ? emp_pic : newUser} className="avatar" />
          </div>
          <div className="col-12 d-flex">
            <img src={emp_pic ? emp_pic : newUser} className="sideavatar"/>
            <p className="pt-0 fs-12" style={{paddingLeft: '50px', float: 'right', textAlign: 'right'} }>{staff_name}</p>
          </div>
        </div>
        */

    return (
      <div className="dx-template-wrapper" style={isMobile ? { display: 'flex', marginLeft: 25 } : {}}>

        <div className="name" style={{ background: color }}>
          <div className="col-12 d-flex justify-content-center">
            <img src={emp_pic ? emp_pic : newUser} className="avatar" />
          </div>
          <div className="col-12 d-flex justify-content-center">
            <p className="text-center pt-2">{staff_name}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default ResourceCell;
